export default __webpack_public_path__ + "static/media/two.f5d63a25.svg";